export default "__VITE_PUBLIC_ASSET__0ad36145__"